const isDev = () => !process.env.NODE_ENV || process.env.NODE_ENV === 'development'

const EnvService = {
	get url() {
		return isDev()
			? "https://cocktails-svc-321354962560.us-east1.run.app"
			: "https://api.cocktails.jtschwartz.com"
	}
}

export default EnvService
